import { useSetPageTitle } from "../../hooks/useSetPageTitle";
import { useIsMobile } from "../../hooks/useMobile";
import { SidebarProvider, SidebarTrigger } from "../../components/ui/sidebar";
import DashboardSidebar from "../dashboard/components/dashboard-sidebar";
import { DashboardMenubar } from "src/components/menubar/menubar";
import { useNavigate } from "react-router-dom";
import { ReactComponent as BackArrow } from 'src/assets/icons-redesign/back-arrow.svg';
import BillingTable from './components/billing-table.component';

const BillingPage = () => {
  useSetPageTitle('Billing');
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();

  return (
    <SidebarProvider>
      <DashboardSidebar activePage="/billing" />
      <div className="flex flex-col w-full grow p-4 md:p-10 gap-6 h-screen overflow-hidden">
        <div className="flex gap-4 items-center flex-shrink-0">
          {isMobile && (
            <div className="flex size-12 items-center justify-center">
              <SidebarTrigger />
            </div>
          )}
          <div
            className='bg-white rounded-full shadow-md p-2 cursor-pointer w-[34px] h-[34px] flex items-center justify-center mb-1'
            onClick={() => navigate(-1)}
          >
            <BackArrow className="size-[18px]" />
          </div>
          <span className="text-3xl mt-2 md:text-5xl md:mt-0">
            Billing
          </span>
          <div className="items-end ml-auto">
            <DashboardMenubar />
          </div>
        </div>
        <BillingTable />
      </div>
    </SidebarProvider>
  );
};

export default BillingPage;